module.exports = __webpack_public_path__ + "img/undo-left-square.f69836e0.svg";